import { call, put } from 'redux-saga/effects';
import {
  getTaxRateTemplatesFailure,
  getTaxRateTemplatesSuccess,
} from '../actions';
import { getTaxRateTemplates } from '../api';
import { GetTaxRateTemplatesRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* getTaxRateTemplatesSaga(
  action: GetTaxRateTemplatesRequestAction
) {
  try {
    let err: ApiError | null;
    const response = yield call(getTaxRateTemplates);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const templates = response?.data?.templates || [];
    yield put(getTaxRateTemplatesSuccess(templates));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(getTaxRateTemplatesFailure());
  }
}

